import { useBack } from "../http";
import { ComparationEventsDTO } from "../types/ComparationEventsDTO";
import { ComparationsDTO } from "../types/ComparationsDTO";
import { Execution } from "../types/Execution";

export class ExecutionService {
	constructor() {}
	axiosInstance = useBack();
	urlDefault = "/executions";

	async getExecutions() {
		try {
			const response = await this.axiosInstance
				.get<Execution[]>(this.urlDefault);
			return {...response };
		} catch (error) {
			console.log(`Não foi possível obter as execuções`, error);
			return undefined;
		}
	}

	async getExecutionEvents() {
		try {
			const response = await this.axiosInstance
				.get<Execution[]>(this.urlDefault + '/events');
			return {...response };
		} catch (error) {
			console.log(`Não foi possível obter as execuções de eventos`, error);
			return undefined;
		}
	}

	async getExecutionById(id: string | undefined) {
		if (!id) return null;
		const url = this.urlDefault + '/' + id;
		try {
			const response = await this.axiosInstance.get<ComparationsDTO>(url);
			return {...response };
		} catch (error) {
			console.log(`Não foi possível obter a execução de id ${id}`, error);
			return undefined;
		}
	}

	async getExecutionEventsById(id: string | undefined) {
		if (!id) return null;
		const url = `${this.urlDefault}/events/${id}`;
		try {
			const response = await this.axiosInstance.get<ComparationEventsDTO>(url);
			return {...response };
		} catch (error) {
			console.log(`Não foi possível obter a execução de eventos de id ${id}`, error);
			return undefined;
		}
	}

	async downloadResult(id: number) {
		return this.axiosInstance.get(`${this.urlDefault}/events/${id}/result`, {
			responseType: "blob",
		});
	}
}